import cn from "classnames";
import Loader from "components/shared/loader";
import { notificationFlags, notificationThresholdTypes } from "helpers/enums";
import Tooltip from "rc-tooltip";
import React, { Component, Fragment } from "react";

class NotificationSettings extends Component {
    state = {
        data: this.props.data,
        shouldUpdate: false,
        isLoading: false,
    };

    update = () => {
        const { shouldUpdate, data } = this.state;
        if (shouldUpdate) {
            this.setState({ isLoading: true });
            return this.props
                .action(data)
                .then((res) => res && this.props.update())
                .then(() => this.setState({ shouldUpdate: false, isLoading: false }));
        }
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader prefix="margin-center" />;
        }
        return (
            <div className="row">
                <div className="col-12 d-flex justify-content-between pb-3">
                    <h5>Настройки уведомлений</h5>
                    <span
                        className="d-flex align-items-center font-size-14 cursor-pointer"
                        onClick={() => {
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    doNotSendNotificationsAtNight: !this.state.data.doNotSendNotificationsAtNight,
                                },
                                shouldUpdate: true,
                            });
                        }}
                    >
                        <span
                            className={cn("checkbox checkbox--inline mr-2", {
                                "checkbox--checked": this.state.data.doNotSendNotificationsAtNight,
                            })}
                            name="doNotSendNotificationsAtNight"
                        />
                        Не отправлять уведомления в ночное время
                    </span>
                </div>
                <div className="col-12 table-responsive pb-3">
                    <table className="table table-striped table-sm table--vertical-centered">
                        <thead>
                            <tr>
                                <th>Название</th>
                                <th>Значение параметра</th>
                                {notificationFlags.map(this.renderHeadItem)}
                            </tr>
                        </thead>
                        <tbody>{this.state.data.notificationOptions.map(this.renderNotificationItem)}</tbody>
                    </table>
                </div>
            </div>
        );
    };

    renderHeadItem = (option, index) => {
        const allChecked = !this.state.data.notificationOptions.some((item) => {
            const checked = (item.flags & option.intValue) === option.intValue;
            const readOnly = (item.readOnlyFlags & option.intValue) === option.intValue;

            return !readOnly && !checked;
        });

        return (
            <th key={index} className="text-center">
                {option.label}
                <br />
                <Tooltip
                    overlay={
                        allChecked ? "Отключить все уведомления данного типа" : "Включить все уведомления данного типа"
                    }
                    placement="top"
                >
                    <span
                        className={cn("checkbox mx-auto mt-3", { "checkbox--checked": allChecked })}
                        onClick={this.toggleAllCheckbox.bind(this, option.intValue, !allChecked)}
                    />
                </Tooltip>
            </th>
        );
    };

    thresholdChange = (item, { target }) => {
        item.threshold = parseInt(target.value || 0);
        const { data } = this.state;
        data.notificationOptions = data.notificationOptions.map((option) => (option.id === item.id ? item : option));

        this.setState({ data, shouldUpdate: true });
    };

    toggleAllCheckbox = (optionIntValue, newValue) => {
        const { data } = this.state;
        data.notificationOptions = data.notificationOptions.map((item) => {
            const readOnly = (item.readOnlyFlags & optionIntValue) === optionIntValue;
            if (readOnly) {
                return item;
            }
            const checked = (item.flags & optionIntValue) === optionIntValue;
            if (checked === newValue) {
                return item;
            }
            item.flags = newValue ? item.flags + optionIntValue : item.flags - optionIntValue;
            return item;
        });

        this.setState({ data, shouldUpdate: true });
    };

    toggleCheckbox = (item, intValue, value) => {
        const { data } = this.state;
        data.notificationOptions = data.notificationOptions.map((option) => {
            if (option.id === item.id) {
                item.flags = value ? item.flags + intValue : item.flags - intValue;
                return item;
            } else {
                return option;
            }
        });

        this.setState({ data, shouldUpdate: true });
    };

    renderField = (props) => {
        const { thresholdType, value, onChange } = props;
        const thresholdOption = notificationThresholdTypes.find((option) => option.value === thresholdType);
        const thresholdLabel = thresholdOption && thresholdOption.label;
        return (
            <>
                <input
                    className="form-control form-control-xs d-inline threshold-input mr-2"
                    type="text"
                    value={value}
                    onChange={onChange}
                />
                {thresholdLabel}
            </>
        );
    };

    renderNotificationItem = (item, index) => {
        const renderFlagItem = (option, i) => {
            const checked = (item.flags & option.intValue) === option.intValue;
            const readOnly = (item.readOnlyFlags & option.intValue) === option.intValue;
            const checkboxCname = cn("checkbox mx-auto", {
                "checkbox--checked": checked,
                "checkbox--disabled": readOnly,
            });
            return (
                <td key={i} className="text-center">
                    <span
                        className={checkboxCname}
                        onClick={readOnly ? undefined : this.toggleCheckbox.bind(this, item, option.intValue, !checked)}
                    />
                </td>
            );
        };

        const renderExtraThreshold = (extraThresholdsInfo, index) => {
            const { thresholdsMaxCount, type, thresholdType } = extraThresholdsInfo;
            const { id, ...rest } = item;
            const extraThreshold = rest.extraThresholds?.find((el) => el.type === type);
            const addItem = () => {
                const { data } = this.state;
                const findThreshold = data.notificationOptions.find((el) => el.id === id);
                if (findThreshold.extraThresholds && findThreshold.extraThresholds.length) {
                    const findExtraThreshold = findThreshold.extraThresholds.find((el) => el.type === type);
                    if (findExtraThreshold.thresholds.length === thresholdsMaxCount) {
                        return null;
                    }
                    findExtraThreshold.thresholds = [...findExtraThreshold.thresholds, ""];
                } else {
                    findThreshold.extraThresholds = [{ thresholds: [""], type }];
                }
                this.setState({ data, shouldUpdate: true });
            };
            const removeItem = (index) => {
                const { data } = this.state;
                data.notificationOptions
                    .find((el) => el.id === id)
                    .extraThresholds.find((el) => el.type === type)
                    .thresholds.splice(index, 1);
                this.setState({ data, shouldUpdate: true });
            };
            return (
                <Fragment key={index}>
                    {extraThreshold &&
                        extraThreshold.thresholds.length > 0 &&
                        extraThreshold.thresholds.map((el, index) => {
                            const fieldProps = {
                                thresholdType,
                                value: el,
                                onChange: (e) => {
                                    const value = e.target.value;
                                    const { data } = this.state;
                                    data.notificationOptions
                                        .find((el) => el.id === id)
                                        .extraThresholds.find((el) => el.type === type).thresholds[index] = value;
                                    this.setState({ data, shouldUpdate: true });
                                },
                            };
                            return (
                                <div key={index} className="d-flex align-items-center my-1">
                                    {this.renderField(fieldProps)}
                                    <div
                                        className="icon-uEA07-delite text-danger cursor-pointer ml-2 small"
                                        onClick={() => removeItem(index)}
                                    ></div>
                                </div>
                            );
                        })}
                    {(!extraThreshold?.thresholds || extraThreshold?.thresholds.length < thresholdsMaxCount) && (
                        <div className="my-1">
                            <div className="link small" onClick={addItem}>
                                <i className="icon-uEA01-add small pr-1" />
                                Добавить
                            </div>
                        </div>
                    )}
                </Fragment>
            );
        };

        const renderExtraThresholds = () => {
            const { extraThresholdsInfo } = item;
            if (!(extraThresholdsInfo && extraThresholdsInfo.length)) {
                return null;
            }
            return extraThresholdsInfo.map(renderExtraThreshold);
        };

        const renderThreshold = () => {
            const { thresholdType, threshold } = item;
            if (thresholdType === "None") {
                return null;
            }
            const fieldProps = {
                thresholdType,
                value: threshold,
                onChange: this.thresholdChange.bind(this, item),
            };
            return (
                <>
                    {this.renderField(fieldProps)}
                    {renderExtraThresholds()}
                </>
            );
        };
        return (
            <tr key={index}>
                <td>
                    {item.displayName}
                    {item.hint && (
                        <Tooltip placement="top" overlay={item.hint} overlayClassName="tooltip--sm">
                            <span className="float-right">
                                <i className="icon-uEA59-question book-form__tooltip-icon" />
                            </span>
                        </Tooltip>
                    )}
                    {item.extraThresholdsInfo &&
                        item.extraThresholdsInfo.length > 0 &&
                        item.extraThresholdsInfo.map((el, i) => (
                            <div key={i} className="mt-2 text-muted">
                                {el.displayName}
                            </div>
                        ))}
                </td>
                <td>{renderThreshold()}</td>
                {notificationFlags.map(renderFlagItem)}
            </tr>
        );
    };

    renderButton = () => {
        const cname = cn("btn btn-brand", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.update}>
                    Обновить
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="card card-body mb-3" id="notification-settings">
                {this.renderBody()}
                {this.renderButton()}
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <NotificationSettings {...props} initialState={props.data} />;

export default ConfiguredPanel;
